import { createContext } from 'react';

const BruceModeContext = createContext(null);

export default BruceModeContext;
